import { render, staticRenderFns } from "./CoozzyCarousel.vue?vue&type=template&id=446bc546&scoped=true"
import script from "./CoozzyCarousel.vue?vue&type=script&lang=js"
export * from "./CoozzyCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446bc546",
  null
  
)

export default component.exports